/**
* @desc the ngAddTransferTPL provides support for displaying information of Transfer in Purchase 1
*/
webClient.directive('ngTransferDrawer', ['$window', 'templateService', '$timeout',
    function ($window, templateService, $timeout) {
        var directive = {};
        directive.restrict = 'EA';
        directive.scope = {
            purchaseid: "=",
            partialtransferinfo: "=",
            alltransferinfo: "=",
            draweropened: "=",
            sessionid: "=",
            onclose: "&",
            proposenewpossibilities: "&"
        };
        directive.link = function ($scope, $element) {
            templateService.compile($scope, $element, 'tpl/_TransferDrawerTPL.html');
            $scope.getTemplateUrl = $window.getTemplateUrl;

            $scope.productDetails = null; 
            $scope.offerDetails = null;
            let hasTriggeredFallback = false; 

            $scope.productDetailsForSelectedSegment = null; 
            $scope.offerDetailsForSelectedSegment = null;
            $scope.isProductDrawerContentLoading = true;
            $scope.isOfferDrawerContentLoading = true
            function getTransferProductDetails() {
                $scope.productDetails = null;
                $scope.productDetailsForSelectedSegment = null; 
                $scope.isProductDrawerContentLoading = true;
                const sessionId = $scope.sessionid;
                const possibilityId = $scope.partialtransferinfo.possibilityId;
                const purchaseId = $scope.purchaseid;
                const culture = window.site.culture;

                window.Typescript.TravelPlateform.Services.TravelPlateformService.getTransferProductDetails(sessionId, possibilityId, purchaseId, culture).then(response => {
                    console.log(response);
                    //TODO check response status 
                    $scope.productDetails = response.data.informations;
                    if ($scope.segmentToShow && $scope.productDetails) {
                        $scope.productDetailsForSelectedSegment =
                            $scope.productDetails.find(info => info.segmentId === $scope.segmentToShow.segmentId) || null;
                        updateProductDrawerContent();
                        $scope.isProductDrawerContentLoading = false;
                    }
                }).catch(error => {
                    const status = error.response?.status;
                    if (status === 424) {
                        console.error('Erreur getTransferProductDetails :', error);
                        if (!hasTriggeredFallback) {
                            $scope.proposenewpossibilities();
                            hasTriggeredFallback = true;
                        }
                    } else {
                        window.location.href = '/error/00666';
                    }
                });
            }

            function getTransferOfferDetails() {
                $scope.offerDetails = null;
                $scope.offerDetailsForSelectedSegment = null;
                $scope.isOfferDrawerContentLoading = true;
                const sessionId = $scope.sessionid;
                const possibilityId = $scope.partialtransferinfo.possibilityId;
                const purchaseId = $scope.purchaseid;
                const culture = window.site.culture;
                
                window.Typescript.TravelPlateform.Services.TravelPlateformService.getTransferOfferDetails(sessionId, possibilityId, purchaseId, culture).then(response => {
                    console.log(response);
                    //TODO check response status 
                    $scope.offerDetails = response.data;
                    if ($scope.segmentToShow && $scope.offerDetails && $scope.offerDetails.policies) {
                        $scope.offerDetailsForSelectedSegment =
                            $scope.offerDetails.policies.find(policy => policy.segmentId === $scope.segmentToShow.segmentId) || null;
                        updateOfferDrawerContent();
                        $scope.isOfferDrawerContentLoading = false

                    }
                }).catch(error => {
                    const status = error.response?.status;
                    if (status === 424) {
                        console.error('Erreur getTransferOfferDetails :', error);
                        if (!hasTriggeredFallback) {
                            $scope.proposenewpossibilities();
                            hasTriggeredFallback = true;
                        }
                    } else if (status === 410) {
                        window.location.href = '/error/00666';
                    }
                    else {
                        $timeout(() => {
                            $scope.isOfferDrawerContentLoading = false;
                        }, 0);
                    }
                });
            }

            $scope.$watch('alltransferinfo', function (newValue) {
                if (newValue && newValue.segments) {
                    updateProductDrawerContent();
                    updateOfferDrawerContent();
                    $scope.isProductDrawerContentLoading = false;
                    $scope.isOfferDrawerContentLoading = false;
                    $scope.vehicleDescription = $scope.alltransferinfo.vehicle.description;
                }
            });

            $scope.$watch('partialtransferinfo', function (newValue) {
                if (newValue && newValue.segments) {
                    const segments = newValue.segments;
                    $scope.segmentToShow = segments[0];
                    $scope.activeTabIndex = 0;
                    $scope.hasTwoSegments = $scope.partialtransferinfo.segments.length === 2;
                    hasTriggeredFallback = false; 
                    $scope.vehicleDescription = $scope.partialtransferinfo.vehicle.description;

                    getTransferOfferDetails();
                    getTransferProductDetails();
                }
            });

            $scope.selectSegment = function (index) {
                $scope.activeTabIndex = index;
                $scope.segmentToShow = $scope.partialtransferinfo.segments[index];
                if ($scope.offerDetails && $scope.offerDetails.policies)
                    $scope.offerDetailsForSelectedSegment =
                        $scope.offerDetails.policies.find(policy => policy.segmentId === $scope.segmentToShow.segmentId) || null;
                if ($scope.productDetails) {
                    $scope.productDetailsForSelectedSegment =
                        $scope.productDetails.find(info => info.segmentId === $scope.segmentToShow.segmentId) || null;
                }

                updateProductDrawerContent();
                updateOfferDrawerContent();
            };

            $scope.getCountryNameByCode = function (countryCode) {
                if (!$scope.countriesCode || !countryCode) return '';

                const country = countriesCode.find(c => c.iso === countryCode);
                return country ? country.name : '';
            };

            function updateProductDrawerContent() {
                if ($scope.alltransferinfo && $scope.alltransferinfo.segments && $scope.alltransferinfo.selectedSegmentIndex != null) {
                    $scope.meetingPoint = $scope.alltransferinfo.segments[0].meetingPoint?.instructions;
                    $scope.maxPassengers = $scope.alltransferinfo.vehicle.maxPassengers;
                    $scope.maxLuggage = $scope.alltransferinfo.vehicle.maxLuggage;
                    $scope.segmentDepartureFullDate = getLongFormattedDate($scope.alltransferinfo.segments[0].start, "-", false);
                    $scope.thumbnailUrl = $scope.alltransferinfo.vehicle.thumbnail;
                    $scope.transferType = $scope.alltransferinfo.transferType;
                    $scope.segmentAccomm = window.$scope.bkgData.accommodations[0];

                    $scope.cancellationPoliciesMessages = ($scope.alltransferinfo.policies.find(p =>
                        p.segmentId === $scope.alltransferinfo.segments[0].segmentId
                    ) || {}).cancellationMessages || [];                    

                    var segmentTrajectOriginInfos = window.$scope.bkgData.purchaseResponse.itineraries[$scope.alltransferinfo.selectedSegmentIndex].origin;
                    var segmentTrajectDestinationInfos = window.$scope.bkgData.purchaseResponse.itineraries[$scope.alltransferinfo.selectedSegmentIndex].destination;

                    switch ($scope.alltransferinfo.segments[0].from.type) {
                        case "Airport":
                            var segmentTrajectInfo = window.$scope.bkgData.purchaseResponse.itineraries[$scope.alltransferinfo.selectedSegmentIndex].segments.last();
                            //use the traject destination because we are displaying from data
                            $scope.fromLabel = `${segmentTrajectDestinationInfos.airportName} (${segmentTrajectDestinationInfos.airportIata})`;
                            $scope.fromCityCountry = `${segmentTrajectDestinationInfos.cityName}, ${segmentTrajectDestinationInfos.countryName}`;

                            // Test if the last segment of the traject is a train
                            if (railHelper.IsTrain(segmentTrajectInfo.equipment.reference)) {
                                $scope.fromPictoClass = "icon-new-train";
                                $scope.comingFromInfos = segmentTrajectOriginInfos.airportName;
                                $scope.fromTrajectNumber = segmentTrajectInfo.flightNumber;
                                $scope.isTrain = true;
                            } else {
                                $scope.fromPictoClass = "icon-new-airplane";
                                $scope.comingFromInfos = `${segmentTrajectOriginInfos.cityName} (${segmentTrajectOriginInfos.airportName}) (${segmentTrajectOriginInfos.airportIata})`;
                                $scope.fromTrajectNumber = segmentTrajectInfo.airline.iata + segmentTrajectInfo.flightNumber;
                                $scope.isTrain = false;
                            }
                            break;
                        case "Hotel":
                            $scope.fromLabel = $scope.segmentAccomm.accomName;
                            $scope.fromCityCountry = `${$scope.segmentAccomm.cityName}, ${getCountryNameByCityCode($scope.segmentAccomm.cityCode)}`;
                            $scope.fromPictoClass = "icon-new-building";
                            $scope.fromTrajectNumber = null;
                            $scope.comingFromInfos = null;
                            break;
                    }

                    switch ($scope.alltransferinfo.segments[0].to.type) {
                        case "Airport":
                            var segmentTrajectInfo = window.$scope.bkgData.purchaseResponse.itineraries[$scope.alltransferinfo.selectedSegmentIndex].segments.first();

                            //use the traject origin because we are displaying to data
                            $scope.toLabel = `${segmentTrajectOriginInfos.airportName} (${segmentTrajectOriginInfos.airportIata})`;
                            $scope.toCityCountry = `${segmentTrajectOriginInfos.cityName}, ${segmentTrajectOriginInfos.countryName}`;

                            // Test if the last segment of the traject is a train
                            if (railHelper.IsTrain(segmentTrajectInfo.equipment.reference)) {
                                $scope.toPictoClass = "icon-new-train";
                                $scope.goingToInfos = segmentTrajectDestinationInfos.airportName;
                                $scope.toTrajectNumber = segmentTrajectInfo.flightNumber;
                                $scope.isTrain = true;
                            } else {
                                $scope.toPictoClass = "icon-new-airplane";
                                $scope.goingToInfos = `${segmentTrajectDestinationInfos.cityName} (${segmentTrajectDestinationInfos.airportName}) (${segmentTrajectDestinationInfos.airportIata})`;
                                $scope.toTrajectNumber = segmentTrajectInfo.airline.iata + segmentTrajectInfo.flightNumber;
                                $scope.isTrain = false;

                            }
                            break;
                        case "Hotel":
                            $scope.toLabel = $scope.segmentAccomm.accomName;
                            $scope.toCityCountry = `${$scope.segmentAccomm.cityName}, ${getCountryNameByCityCode($scope.segmentAccomm.cityCode)}`;
                            $scope.toPictoClass = "icon-new-building";
                            $scope.toTrajectNumber = null;
                            $scope.goingToInfos = null;
                            break;
                    }
                }
                else if ($scope.productDetailsForSelectedSegment) {
                    $timeout(() => {
                        $scope.meetingPoint = $scope.productDetailsForSelectedSegment.meetingPoint?.instructions;
                        $scope.maxPassengers = $scope.partialtransferinfo.vehicle.maxPassengers;
                        $scope.maxLuggage = $scope.partialtransferinfo.vehicle.maxLuggage;
                        $scope.segmentDepartureFullDate = getLongFormattedDate($scope.segmentToShow.start, "-", false);
                        $scope.thumbnailUrl = $scope.partialtransferinfo.vehicle.thumbnail;
                        $scope.transferType = $scope.partialtransferinfo.transferType;
                        $scope.segmentAccomm = window.$scope.bkgData.accommodations[0];

                        var segmentTrajectOriginInfos = window.$scope.bkgData.purchaseResponse.itineraries[$scope.activeTabIndex].origin;
                        var segmentTrajectDestinationInfos = window.$scope.bkgData.purchaseResponse.itineraries[$scope.activeTabIndex].destination;

                        switch ($scope.segmentToShow.from.type) {
                            case "Airport":
                                var segmentTrajectInfo = window.$scope.bkgData.purchaseResponse.itineraries[$scope.activeTabIndex].segments.last();
                                //use the traject destination because we are displaying from data
                                $scope.fromLabel = `${segmentTrajectDestinationInfos.airportName} (${segmentTrajectDestinationInfos.airportIata })`;
                                $scope.fromCityCountry = `${segmentTrajectDestinationInfos.cityName}, ${segmentTrajectDestinationInfos.countryName}`;

                                // Test if the last segment of the traject is a train
                                if (railHelper.IsTrain(segmentTrajectInfo.equipment.reference)) {
                                    $scope.fromPictoClass = "icon-new-train";
                                    $scope.comingFromInfos = segmentTrajectOriginInfos.airportName; 
                                    $scope.fromTrajectNumber = segmentTrajectInfo.flightNumber;
                                    $scope.isTrain = true;
                                } else {
                                    $scope.fromPictoClass = "icon-new-airplane";
                                    $scope.comingFromInfos = `${segmentTrajectOriginInfos.cityName} (${segmentTrajectOriginInfos.airportName}) (${segmentTrajectOriginInfos.airportIata })`; 
                                    $scope.fromTrajectNumber = segmentTrajectInfo.airline.iata + segmentTrajectInfo.flightNumber;
                                    $scope.isTrain = false;
                                }
                                break;
                            case "Hotel":
                                $scope.fromLabel = $scope.segmentToShow.from.label;
                                $scope.fromCityCountry = `${$scope.segmentAccomm.cityName}, ${getCountryNameByCityCode($scope.segmentAccomm.cityCode)}`;
                                $scope.fromPictoClass = "icon-new-building";
                                $scope.fromTrajectNumber = null;
                                $scope.comingFromInfos = null; 
                                break;
                        }

                        switch ($scope.segmentToShow.to.type) {
                            case "Airport":
                                var segmentTrajectInfo = window.$scope.bkgData.purchaseResponse.itineraries[$scope.activeTabIndex].segments.first();

                                //use the traject origin because we are displaying to data
                                $scope.toLabel = `${segmentTrajectOriginInfos.airportName} (${segmentTrajectOriginInfos.airportIata})`;
                                $scope.toCityCountry = `${segmentTrajectOriginInfos.cityName}, ${segmentTrajectOriginInfos.countryName}`;

                                // Test if the last segment of the traject is a train
                                if (railHelper.IsTrain(segmentTrajectInfo.equipment.reference)) {
                                    $scope.toPictoClass = "icon-new-train";
                                    $scope.goingToInfos = segmentTrajectDestinationInfos.airportName;
                                    $scope.toTrajectNumber = segmentTrajectInfo.flightNumber;
                                    $scope.isTrain = true;
                                } else {
                                    $scope.toPictoClass = "icon-new-airplane";
                                    $scope.goingToInfos = `${segmentTrajectDestinationInfos.cityName} (${segmentTrajectDestinationInfos.airportName}) (${segmentTrajectDestinationInfos.airportIata})`;
                                    $scope.toTrajectNumber = segmentTrajectInfo.airline.iata + segmentTrajectInfo.flightNumber;
                                    $scope.isTrain = false;

                                }
                                break;
                            case "Hotel":
                                $scope.toLabel = $scope.segmentToShow.to.label; 
                                $scope.toCityCountry = `${$scope.segmentAccomm.cityName}, ${getCountryNameByCityCode($scope.segmentAccomm.cityCode)}`;
                                $scope.toPictoClass = "icon-new-building";
                                $scope.toTrajectNumber = null;
                                $scope.goingToInfos = null;
                                break;
                        }
                    }, 0);
                }
            }

            function updateOfferDrawerContent() {
                if ($scope.alltransferinfo && $scope.alltransferinfo.policies) {
                    //Handle Policies
                    $scope.freePolicy = null;
                    $scope.feePolicies = [];
                    // sort asc date "from"
                    const policyEntry = $scope.alltransferinfo.policies
                        .find(policy => policy.segmentId === $scope.alltransferinfo.segments[0].segmentId);

                    if (policyEntry && policyEntry.policy && Array.isArray(policyEntry.policy.policies)) {
                        policyEntry.policy.policies
                            .sort((a, b) => new Date(a.from) - new Date(b.from))
                            .forEach(p => {
                                const displayDate = getLongFormattedDate(p.fees === 0 ? p.to : p.from, "{dateTimeSeperator}");

                                if (p.fees === 0) {
                                    $scope.freePolicy = {
                                        ...p,
                                        displayDate
                                    };
                                } else {
                                    $scope.feePolicies.push({
                                        ...p,
                                        displayDate
                                    });
                                }
                            });
                    }
                }
                else if ($scope.offerDetailsForSelectedSegment) {
                    $timeout(() => {
                        //Handle Policies
                        $scope.freePolicy = null;
                        $scope.feePolicies = [];
                        // sort asc date "from"
                        $scope.offerDetailsForSelectedSegment.policy.policies
                            .sort((a, b) => new Date(a.from) - new Date(b.from))
                            .forEach(p => {
                                const displayDate = getLongFormattedDate(p.fees === 0 ? p.to : p.from, "à");

                                if (p.fees === 0) {
                                    $scope.freePolicy = {
                                        ...p,
                                        displayDate
                                    };
                                } else {
                                    $scope.feePolicies.push({
                                        ...p,
                                        displayDate
                                    });
                                }
                            });
                    }, 0);
                }
            }

            function getCurrentLanguage() {
                const culture = window.site.culture || null;

                if (!culture) return "fr-FR";

                switch (culture.toLowerCase()) {
                    case "it":
                        return "it-IT";
                    case "en":
                        return "en-US";
                    case "nl":
                        return "nl-BE";
                    default:
                        return "fr-FR";
                }
            }

            function getLongFormattedDate(isoDate, separator = ' - ', displayTime = true) {
                const date = new Date(isoDate);

                const day = date.toLocaleDateString(getCurrentLanguage(), { weekday: 'long' });
                const fullDate = date.toLocaleDateString(getCurrentLanguage(), { day: 'numeric', month: 'long', year: 'numeric' });
                const time = date.toLocaleTimeString(getCurrentLanguage(), { hour: '2-digit', minute: '2-digit', hour12: false });

                if (displayTime) {
                    return `${capitalize(day)} ${fullDate} ${separator} ${time}`;
                } else {
                    return `${capitalize(day)} ${fullDate}`;
                }
            }

            // Helper for capitalizing the first char
            function capitalize(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }

            function getCountryNameByCityCode (cityCode) {
                if (!cityCode || cityCode.length < 2) return null;

                const countryCode = cityCode.substring(0, 2).toUpperCase();

                const country = countriesCode.find(c => c.iso === countryCode);

                return country ? country.name : null;
            }
            $scope.$watch('draweropened', function (isOpen) {
                if (isOpen) {
                    $timeout(function () {
                        var closeBtn = $element[0].querySelector('.circle-button--icon');
                        if (closeBtn) closeBtn.focus();
                    }, 0);
                }
            });
        };
        return directive;
    }
]);